<template>
    <div>
            <div class="row my-3">

              <div class="col col-md-12">
                <div class="form-group required">
                  <label class='control-label'>Причина отказа</label>
                  <div><input class="form-control" id="time" v-model="comment" /></div>
                  <div class="invalid-msg" v-if="v$.comment.$error">Поле обязательно для заполнения</div>
                </div>
              </div>

            </div>

            <div>
              <div class="float-right">
                <button class="btn  btn-primary mx-2" v-on:click="save">Отклонить</button>
                <button type="button" class="btn btn-default" v-on:click="close">Закрыть</button>
              </div>
             </div>

    </div>
</template>
<script>
import API from '../api/route'
import Constants from '../../../common/constants'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'


export default {
  name: "RejectWithComment",
  props: {
    signerId:Number,
    routeId:Number
  },
  created() {
  },
  mounted() {
  },
  emits: ['save', 'close'],
  data() {
    return {
        comment: null,
    };
  },
  methods: {
    save() {
        var self = this;

        self.v$.$touch();
        if (self.v$.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error' );
          return;
        }
        API.rejectStep(this.signerId, this.comment, this.routeId).then(function (response) {
            Constants.alert.fire('Сохранение', response.data.message, response.data.success ? 'success' : 'error' );
            if(response.data.success) {
                self.$emit('save');
            }
        });
    },    
    close() {
      this.$emit('close');
    }
  },
  setup: () => ({ v$: useVuelidate() }),
  validations () {
    return {
        comment: { required },
    }
  }
}; 
</script>
<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';

.form-group.required .control-label:after { 
   content:"*";
   color:red;
}
.form-check.required .control-label:after { 
   content:"*";
   color:red;
}
.invalid-msg {
  color:red;
  font-size: 0.75rem;
}
</style>